import React, { FC } from 'react';
import classNames from 'classnames';
import { startCase } from 'lodash';
import { IconProps } from '../../utils/icons';

interface Props {
  text?: string;
  showTextInline?: boolean;
  subText?: string;
  Icon: React.FC<IconProps>;
  iconProps?: IconProps & { shape?: 'circle' | 'square' };
  children?: React.ReactNode;
  panelClassName?: string;
}

export const NoDataView: FC<Props> = ({
  text,
  showTextInline,
  subText,
  Icon,
  iconProps = {},
  children,
  panelClassName,
}) => {
  // SVG stroke/fill presentation attributes cannot resolve var(), so the icon
  // inherits its token color from the wrapper below via currentColor.
  const defaultIconProps = { size: 28, stroke: 'currentColor', shape: 'circle' };

  const props = { ...defaultIconProps, ...iconProps };
  return (
    <div
      className={classNames(
        'flex flex-col items-center justify-center gap-6 mt-40',
        panelClassName
      )}
    >
      {Icon && (
        <div
          className={`flex items-center justify-center p-2 border-muted text-muted rounded-[${
            props.shape === 'circle' ? '50%' : '10px'
          }] border-2`}
        >
          <Icon {...props} width={props?.size} height={props?.size} />
        </div>
      )}
      {text ||
        (subText && (
          <div
            className={classNames(
              'flex flex-col items-center justify-center gap-2 w-[200px]',
              { 'w-full': showTextInline }
            )}
          >
            {text && (
              <div
                className={classNames(
                  'text-text-2 font-circular text-[18px] font-[450] text-center',
                  { 'font-bold': subText }
                )}
              >
                {startCase(text)}
              </div>
            )}
            {subText && (
              <div className="text-text-2 font-circular text-[14px] font-[450] text-center">
                {subText}
              </div>
            )}
          </div>
        ))}

      {children}
    </div>
  );
};
